var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArScavenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 175C58.5774 175 25 141.423 25 100C25 58.5774 58.5774 25 100 25C141.423 25 175 58.5774 175 100C175 141.423 141.423 175 100 175Z",
    fill: "url(#paint0_linear_26801_2717)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 46.0193C101.379 44.6602 98.6206 44.6602 96.445 46.0193L55.4796 71.6086V128.391L96.445 153.981L96.4446 153.98L96.445 153.981C98.6206 155.34 101.379 155.34 103.555 153.981L144.52 128.391V71.6086L103.555 46.0193Z",
    fill: "url(#paint1_linear_26801_2717)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.52 71.6086L180.839 94.2957C185.054 96.9282 185.054 103.072 180.839 105.704L144.52 128.391V71.6086Z",
    fill: "url(#paint2_linear_26801_2717)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1608 94.2961L55.4796 71.6086V128.391L19.1608 105.705C14.9464 103.072 14.9464 96.9285 19.1608 94.2961Z",
    fill: "url(#paint3_linear_26801_2717)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.805 92.2065L99.1978 99.0069L99.8021 131.054L123.025 116.566C123.025 116.566 123.024 116.566 123.024 116.566C124.253 115.799 125 114.453 125 113.004V83.8894L110.805 92.2065C110.805 92.2065 110.805 92.2065 110.805 92.2065Z",
    fill: "#F59E0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6043 83.8896L99.8022 99.0069V131.054L76.5797 116.565C75.351 115.799 74.604 114.453 74.604 113.004V83.8896H74.6043Z",
    fill: "url(#paint4_linear_26801_2717)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.799 70.042L74.6042 83.8894L99.8021 99.6112L112.099 91.939C112.099 91.939 112.099 91.939 112.099 91.939L125 83.8896L102.024 69.5545C100.664 68.706 98.9401 68.706 97.5805 69.5545L97.5804 69.5546C97.5804 69.5545 97.5804 69.5545 97.5804 69.5545L97.3432 69.7025L96.7991 70.0419C96.799 70.042 96.799 70.042 96.799 70.042Z",
    fill: "url(#paint5_linear_26801_2717)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6879 23.9999H85.9896H86.6668H132.156C139.404 23.9999 145.335 29.9303 145.335 37.1787V159.408C143.44 160.934 141.466 162.367 139.42 163.7V163.701C138.738 164.145 138.048 164.578 137.351 165V37.1787C137.351 34.3218 135.013 31.9844 132.156 31.9844H127.576C125.699 31.9844 123.94 32.9038 122.868 34.446C121.796 35.9879 120.037 36.9073 118.159 36.9073H85.4702L81.6849 36.9073C79.807 36.9073 78.0481 35.9879 76.9764 34.446C75.9047 32.9038 74.1457 31.9844 72.2679 31.9844H67.688C64.8311 31.9844 62.4937 34.3218 62.4937 37.1787V165C61.7958 164.578 61.1056 164.145 60.4235 163.701V163.698C58.3781 162.366 56.4041 160.934 54.509 159.408V37.1787C54.509 29.9303 60.4394 23.9999 67.6879 23.9999Z",
    fill: "url(#paint6_linear_26801_2717)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.5 128C142.94 128 145.291 128.377 147.503 129.068L147.506 129.063C157.063 132.044 164 140.961 164 151.5C164 152.328 163.957 153.147 163.873 153.953L163.87 153.954C163.088 161.48 158.754 167.949 152.573 171.658C152.574 171.659 152.576 171.659 152.578 171.66C149.048 173.779 144.917 175 140.5 175C127.521 175 117 164.479 117 151.5C117 142.084 122.54 133.966 130.536 130.216C130.536 130.217 130.536 130.217 130.536 130.218C133.561 128.798 136.936 128 140.5 128Z",
    fill: "url(#paint7_linear_26801_2717)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.127 160.94C126.348 161.024 126.575 161.064 126.799 161.064C127.56 161.064 128.277 160.601 128.564 159.847L129.536 157.294H136.191L137.153 159.841C137.521 160.818 138.61 161.31 139.586 160.942C140.562 160.573 141.054 159.484 140.686 158.508L134.974 143.373C134.972 143.369 134.971 143.365 134.969 143.361C134.964 143.347 134.959 143.334 134.954 143.321C134.608 142.48 133.796 141.936 132.885 141.936H132.884C131.972 141.936 131.161 142.482 130.816 143.325C130.813 143.332 130.81 143.34 130.807 143.347C130.804 143.354 130.801 143.361 130.799 143.368L125.034 158.503C124.663 159.477 125.152 160.569 126.127 160.94ZM134.766 153.518L132.879 148.518L130.975 153.518H134.766Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.616 161.063C153.092 161.063 152.571 160.847 152.198 160.423L145.75 153.096C145.06 152.313 145.136 151.12 145.919 150.431C146.702 149.742 147.896 149.818 148.585 150.601L155.033 157.927C155.722 158.71 155.646 159.903 154.863 160.593C154.504 160.908 154.059 161.063 153.616 161.063Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.316 161.063C144.273 161.063 143.427 160.218 143.427 159.175V143.824C143.427 142.781 144.273 141.936 145.316 141.936C146.359 141.936 147.204 142.781 147.204 143.824V159.175C147.204 160.218 146.359 161.063 145.316 161.063Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.349 153.709C144.311 153.709 143.467 152.871 143.461 151.833C143.461 151.833 143.442 148.928 143.442 147.814C143.442 146.903 143.432 143.83 143.432 143.83C143.431 143.328 143.629 142.847 143.983 142.491C144.337 142.136 144.819 141.936 145.32 141.936H149.4C152.765 141.936 155.504 144.572 155.504 147.813C155.504 151.054 152.765 153.691 149.4 153.691C148.271 153.691 145.36 153.709 145.36 153.709C145.357 153.709 145.352 153.709 145.349 153.709ZM147.215 145.713C147.217 146.532 147.219 147.398 147.219 147.814C147.219 148.303 147.223 149.14 147.227 149.922C148.028 149.919 148.893 149.915 149.4 149.915C150.662 149.915 151.727 148.953 151.727 147.814C151.727 146.675 150.662 145.713 149.4 145.713L147.215 145.713Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_2717",
    x1: 25,
    y1: 36.7188,
    x2: 167.969,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_2717",
    x1: 100,
    y1: 118.5,
    x2: 100,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_2717",
    x1: 100,
    y1: 118.5,
    x2: 100,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_2717",
    x1: 100,
    y1: 118.5,
    x2: 100,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_2717",
    x1: 75.6871,
    y1: 85.2878,
    x2: 99.8621,
    y2: 130.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00667681,
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_2717",
    x1: 99.862,
    y1: 68.9697,
    x2: 95.6586,
    y2: 131.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47085,
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_2717",
    x1: 99.9219,
    y1: 23.9999,
    x2: 99.9219,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_2717",
    x1: 122.141,
    y1: 128,
    x2: 176.492,
    y2: 161.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArScavenger);
export default __webpack_public_path__ + "static/media/AR-Scavenger.6588ef17ee35948326024e34fb7e7b30.svg";
export { ForwardRef as ReactComponent };